import React from "react";
import {faBoxesStacked} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default function DeliveryBB() {
    return (
        <FontAwesomeIcon style={{fontSize: 22}} icon={faBoxesStacked} />
    );
};
